module.exports = __webpack_public_path__ + "assets/img/3s.7bd607dc.png";